import { produce } from "immer";
import { DEFAULT_CARE_PLAN_AUDIT_PER_PAGE } from "./schema";
import {
  FETCH_CARE_PLAN_AUDIT,
  FETCH_CARE_PLAN_AUDIT_SUCCESS,
  FETCH_CARE_PLAN_AUDIT_FAILURE,
  RESET_CARE_PLAN_AUDIT,
} from "./constants";

const emptyPagination = {
  current_page: 1,
  last_page: 1,
  total: 0,
  per_page: DEFAULT_CARE_PLAN_AUDIT_PER_PAGE,
};

const extractPaginator = (response) => {
  if (!response || typeof response !== "object") return null;
  if (response.data && Array.isArray(response.data.data)) return response.data;
  if (Array.isArray(response.data) && response.current_page != null) {
    return response;
  }
  return null;
};

export const initialState = {
  rows: [],
  pagination: emptyPagination,
  loading: false,
  loadingMore: false,
  error: false,
};

const CarePlanAuditReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CARE_PLAN_AUDIT: {
        const append = Boolean(action.payload?.append);
        if (append) {
          draft.loadingMore = true;
        } else {
          draft.loading = true;
          draft.loadingMore = false;
          draft.rows = [];
          draft.pagination = emptyPagination;
        }
        draft.error = false;
        break;
      }
      case FETCH_CARE_PLAN_AUDIT_SUCCESS: {
        const append = Boolean(action.payload?.append);
        const response = action.payload?.response ?? action.payload ?? null;
        const paginator = extractPaginator(response);
        const nextRows = Array.isArray(paginator?.data) ? paginator.data : [];
        const nextPagination = paginator
          ? {
              current_page: Number(paginator.current_page) || 1,
              last_page: Number(paginator.last_page) || 1,
              total: Number(paginator.total) || 0,
              per_page:
                Number(paginator.per_page) || DEFAULT_CARE_PLAN_AUDIT_PER_PAGE,
            }
          : emptyPagination;

        draft.loading = false;
        draft.loadingMore = false;
        draft.error = false;
        draft.pagination = nextPagination;
        if (append) {
          const seen = new Set(
            draft.rows.map((row) => row?.id).filter(Boolean),
          );
          nextRows.forEach((row) => {
            if (row?.id && seen.has(row.id)) return;
            if (row?.id) seen.add(row.id);
            draft.rows.push(row);
          });
        } else {
          draft.rows = nextRows;
        }
        break;
      }
      case FETCH_CARE_PLAN_AUDIT_FAILURE: {
        const append = Boolean(action.payload?.append);
        draft.loading = false;
        draft.loadingMore = false;
        draft.error = true;
        if (!append) {
          draft.rows = [];
          draft.pagination = emptyPagination;
        }
        break;
      }
      case RESET_CARE_PLAN_AUDIT:
        draft.rows = [];
        draft.pagination = emptyPagination;
        draft.loading = false;
        draft.loadingMore = false;
        draft.error = false;
        break;
      default:
        break;
    }
  });

export default CarePlanAuditReducer;
